import { useState } from "react";

export default function StepSubcategory({ onNext, onBack, formData }) {
  const [subcategory, setSubcategory] = useState(formData.subcategory || "");

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Select Subcategory (optional)</h2>
      <input
        className="w-full p-2 border rounded mb-4"
        value={subcategory}
        onChange={e => setSubcategory(e.target.value)}
        placeholder="Type or leave blank"
      />
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button
          className="btn btn-primary"
          onClick={() => onNext({ subcategory })}
        >
          Next
        </button>
      </div>
    </div>
  );
}
